<mat-card data-test-id="Open Issues">
  <mat-card-header>
    <h2>Open Issues</h2>
  </mat-card-header>
  <mat-card-content>
    <div class="table-content">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef class="header-border-right">#</th>
          <td mat-cell *matCellDef="let element" class="table-elem-border-right">{{ element.number }}</td>
        </ng-container>

        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let element">
            {{ element.title }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex align-items-center">
              Status
              <button
                mat-icon-button
                class="button-sm-size"
                aria-label="Show Conect Status list info"
                [matMenuTriggerFor]="menuInfo"
                stopPropagationAction
              >
                <mat-icon>info_outline</mat-icon>
              </button>
              <mat-menu #menuInfo="matMenu" class="statusInfo">
                <app-issues-status-info></app-issues-status-info>
              </mat-menu>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-chip-set aria-label="status" class="status-chip chip-size-m" [ngClass]="element.status | statusColor">
              <mat-chip>{{ element.status }}</mat-chip>
            </mat-chip-set>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastUploaded">
          <th mat-header-cell *matHeaderCellDef>Last updated</th>
          <td mat-cell *matCellDef="let element">{{ element.lastUploaded }}</td>
        </ng-container>

        <!-- Table Actions column -->
        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="table-actions-column-small">
            <div class="d-flex align-items-center justify-content-between">
              <mat-icon>expand_content</mat-icon>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{ 'row-expandable': row.url }"
          (click)="row.url && onClickOpenZendeskTicket($event, row.number)"
        ></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="6">
            @if (isLoading()) {
              <div class="empty-table">
                <div class="empty-table-message-info">Loading...</div>
              </div>
            } @else if (!dataSource.getValue().length) {
              <div class="empty-table">
                <div class="empty-table-message-info">{{ emptyListMessage() }}</div>
              </div>
            }
          </td>
        </tr>
      </table>
    </div>
    <button
      mat-button
      color="primary"
      type="button"
      class="action-button mt-2"
      (click)="seeMore()"
      data-test-id="seeMoreBtn"
    >
      See More
    </button>
  </mat-card-content>
</mat-card>
